<template>
    <div>
 <div  :class="['header' , (nav_scroll)==true ? 'nav_scroll':'']">
     <!-- new header -->
    <b-navbar id="nav" :fixed-top="true" type="is-light">
        <template #brand>
            <b-navbar-item class="img_logo_head" tag="router-link" :to="{ path: '/' }">
                <!-- <img
                    src="@/assets/logo_sm.png"
                    alt="logo"
                > -->
                <img :src="get_setting_app.logo" alt="logo">
            </b-navbar-item>
             <span uk-toggle="target:#offcanvas-sidebar"  role="button" aria-label="menu" tabindex="0" class="navbar-burger burger mob_nav"><span aria-hidden="true"></span><span aria-hidden="true"></span><span aria-hidden="true"></span></span>
             <template v-if="authenticated && all_data_cart.status!=402">
            <a  uk-toggle="target: #offcanvas-flip" class="button is-light cart_btn mob_nav">
                    <i class="fas fa-shopping-basket"></i>
                       <span class="cart_no">{{get_count_cart}}</span>
            </a>
            </template>
            <template v-else>
            <a  uk-toggle="target: #offcanvas-flip" class="button is-light cart_btn mob_nav">
                    <i class="fas fa-shopping-basket"></i>
                       <span class="cart_no">0</span>
            </a>
            </template>
        </template>
       <template #start>
            <span v-for="menu in  get_setting_app.menu_top" class="navbar-item" :key="menu.id" :class="[($route.name === 'Meny' ? 'active_meny':'')]">
            <b-navbar-item tag="router-link" :to="{ path: menu.link }" :class="[(menu.page_id === 'menu' ? 'exact_active':'')]">
              <i :class="menu.icon"></i>
              <!-- ico_nav fas fa-home -->
                {{menu.name}}
            </b-navbar-item>
            </span>
        </template>

        <template #end>
            
              <template v-if="authenticated && all_data_cart.status!=402">
               
                   <b-navbar-item tag="div">
                <div class="buttons">
                      <b-field>
            <b-select class="lang_sel" placeholder="Select a name" v-model="active_val" @change.native="changeLang($event)">
                 <option class="enopt" value="EN">🇺🇸&nbsp;&nbsp;English</option>
                <option  class="aropt" value="NO">🇳🇴&nbsp;&nbsp;Norsk</option>
            </b-select>
        </b-field>
            <b-navbar-dropdown class="username_s" :label="`${get_local_string.string_73} ${user.name}`">
                 <b-navbar-item tag="router-link" :to="{ path: '/Profile/user' }">
                {{get_local_string.string_41}}
            </b-navbar-item>
            <b-navbar-item @click.prevent="signOut()">
                 {{get_local_string.string_47}}
            </b-navbar-item>
             </b-navbar-dropdown>
                    <a  uk-toggle="target: #offcanvas-flip" class="button is-light cart_btn">
                      <i class="fas fa-shopping-basket"  aria-hidden="true"></i>
                       <span class="cart_no">{{get_count_cart}}</span>
                    </a>
                </div>
            </b-navbar-item>
               <!--  -->
          </template>
          <!-- if cart is closed -->
          <template v-else-if="authenticated && all_data_cart.status==402">
            <b-navbar-item tag="div">
                <div class="buttons">
                      <b-field>
            <b-select class="lang_sel" placeholder="Select a name" v-model="active_val" @change.native="changeLang($event)">
                 <option class="enopt" value="EN">🇺🇸&nbsp;&nbsp;English</option>
                <option  class="aropt" value="NO">🇳🇴&nbsp;&nbsp;Norsk</option>
            </b-select>
        </b-field>
            <b-navbar-dropdown :label="`${get_local_string.string_73} ${user.name}`">
                 <b-navbar-item tag="router-link" :to="{ path: '/Profile/user' }">
                {{get_local_string.string_41}}
            </b-navbar-item>
            <b-navbar-item @click.prevent="signOut()">
                 {{get_local_string.string_47}}
            </b-navbar-item>
             </b-navbar-dropdown>
                    <a uk-toggle="target: #offcanvas-flip" class="button is-light cart_btn">
                      <i class="fas fa-shopping-basket"  aria-hidden="true"></i>
                       <span class="cart_no">0</span>
                    </a>
                </div>
            </b-navbar-item>
          </template>
            <template v-else>
              <b-navbar-item tag="div">
                <div class="buttons">
                      <b-field>
            <b-select class="lang_sel" placeholder="Select a name" v-model="active_val" @change.native="changeLang($event)">
                 <option class="enopt" value="EN">🇺🇸&nbsp;&nbsp;English</option>
                <option  class="aropt" value="NO">🇳🇴&nbsp;&nbsp;Norsk</option>
            </b-select>
        </b-field>
                    <router-link :to="{ path: '/login' }" class="button is-main">
                        <strong><ion-icon name="log-in-outline"></ion-icon> {{get_local_string.string_75}}</strong>
                    </router-link>
                    <router-link :to="{ path: '/login' }" class="button is-light cart_btn">
                     <i class="fas fa-shopping-basket"  aria-hidden="true"></i>
                       <span class="cart_no">0</span>
                    </router-link>
                </div>
            </b-navbar-item>
          </template>
        </template>
    </b-navbar>
<!--  -->
<!--  -->
       <div id="offcanvas-sidebar" uk-offcanvas>
            <div class="uk-offcanvas-bar">
                <button class="uk-offcanvas-close" type="button" uk-close></button>
                 <div class="logo_sidebar">
                      <img :src="get_setting_app.logo" alt="logo">
                      <!-- <img
                    src="@/assets/logo_ro.png"
                    alt="logo"
                > -->
                 </div>
           <ul class="uk-nav uk-nav-primary uk-nav-left uk-margin-auto-vertical">
            <template v-for="menu in  get_setting_app.menu_top">
               <router-link  :to="{ path: menu.link }" :key="menu.id">
                {{menu.name}}
               </router-link>
            </template>
            <li class="uk-parent">
                <!-- <a > {{get_local_string.string_74}}</a> -->
                <ul class="uk-nav-sub">
                    <li><router-link to="/Profile/user"><ion-icon name="person-circle-outline"></ion-icon>{{get_local_string.string_41}}</router-link></li>
                    <li><a @click.prevent="signOut()"><ion-icon name="log-out-outline"></ion-icon>  {{get_local_string.string_47}}</a></li>
                </ul>
                   <b-field>
            <b-select class="lang_sel" placeholder="Select a name" v-model="active_val" @change.native="changeLang($event)">
                 <option class="enopt" value="EN">🇺🇸&nbsp;&nbsp;English</option>
                <option  class="aropt" value="NO">🇳🇴&nbsp;&nbsp;Norsk</option>
            </b-select>
        </b-field>
            </li>
        </ul>
            </div>
        </div>
    </div>
<!--  -->
  
    </div>
</template>

<script>
import $ from 'jquery';
import {mapGetters , mapActions} from 'vuex';
export default{
    name:'headerApp',
    data(){
        return{
            nav_scroll:false,
             active_val:localStorage.getItem('Fav_lang')
        }
    },
     computed:{
    ...mapGetters({
        authenticated:'auth/authenticated',
        user:'auth/user',
        get_count_cart :'get_count_cart',
        get_setting_app:'get_setting_app',
        all_data_cart:'all_data_cart',
         get_local_string:'get_local_string'
    })
    } ,
    methods:{
        ...mapActions({
            signOutAction :'auth/signOut',
             get_string_api:'get_string_api',
        }) ,
        signOut(){
            this.signOutAction().then(()=>{
                this.$router.replace({
                    name:'Login'
                })
            })
        },
        close_auto_side(){
            const link_side = document.querySelectorAll('#offcanvas-sidebar a');
            link_side.forEach((elem)=>{
                elem.addEventListener('click',()=>{
                    this.uk.offcanvas($('#offcanvas-sidebar')).hide();
                })
            })
            
        },
        scroll_down_page(){
            document.addEventListener('scroll',()=> {
               if(window.scrollY>50){
                   this.nav_scroll = true;
                   $('.flex_title_prod').addClass('scroll_half');
               }
               else{
                   this.nav_scroll = false;
                    $('.flex_title_prod').removeClass('scroll_half');
               }
            });
        },
         changeLang(language){
            if(language.target.value=='EN'){
              window.location.reload();
            localStorage.setItem('Fav_lang', 'EN');
             this.get_string_api();
            }
            else{
            localStorage.setItem('Fav_lang', 'NO');
             window.location.reload();
             this.get_string_api();
            }
        },
    },
    mounted(){
          this.get_string_api().then(()=>{
             this.active_val  = localStorage.getItem('Fav_lang');
        })
        this.close_auto_side();
        this.scroll_down_page()
    }
}
</script>
<style lang="scss">
#nav{
.button.is-main.router-link-exact-active{
    color: black !important;
    font-weight: 600;
}
.cart_btn.router-link-exact-active{
    &::after{
       display: none !important;
    }
}
}

.ico_nav{
    padding-right: 5px;
    padding-bottom: 2px;
}
.navbar-brand{
    position: absolute;
    left: 15px;
    top: -6px;
}
.navbar-start{
margin-left: 150px;
a{
    &:hover{
        color: black !important;
    }
}
}
.navbar-item, .navbar-link {
    color: #fff !important;
}
 .navbar.is-light .navbar-end .navbar-link:hover ,  .navbar.is-light .navbar-end .navbar-link:focus{
    color: black !important;
     &::after{
    border-color: black !important;
}
 }
 .navbar-link::after{
    border-color: white !important;
}
.navbar-dropdown{
    a{
color: black !important;
    }
    
}
.navbar-item.has-dropdown a:hover , .navbar-item.has-dropdown a:focus{
    color: black !important;
    .navbar-link::after{
    border-color: black !important;
}
}
.navbar.is-light{
background: black !important;
}
.cart_btn i{
     color: var(--active_color);
}
// .navbar.is-light .navbar-end .navbar-link::after {
//     border-color: white !important;
// }
// .navbar.is-fixed-top .navbar-item img{
//       filter: invert(1);
// }
// .HomePage , .loginPage{
// .navbar.is-light{
// background: black !important;
// }
// .header.nav_scroll 
// {
//     .navbar.is-light{
//         transition: 0.2s ease-in-out;
//     background-color: #fff !important;
//     box-shadow: 0px 1px 3px #d2d0d0;
// }
// .navbar-item, .navbar-link {
//     color: #000 !important;
// }
// .navbar.is-light .navbar-end .navbar-link::after {
//     border-color: black !important;
// }
//  span.navbar-burger{
//     order: -1;
//     margin-right: auto;
//     margin-left: 10px;
//     color: #000 !important;
//     }
//  .navbar.is-fixed-top .button.is-light{
//     color: var(--active_color);
// }
// .cart_btn .cart_no{
//     background-color: #ffffff;
//     color: var(--active_color);
//     border: 1px solid var(--active_color);
// }
// .cart_btn i{
//      color: var(--active_color);
// }
// .navbar.is-fixed-top .navbar-item img{
//     filter:none !important;
// }


// }
// }
.navbar-menu{
        padding-top: 10px;
}
.navbar{
    padding-bottom: 10px !important;
}
.username_s{
    font-size: 16px;
    margin-top: -5px;
}
.mob_nav{
    display: none !important;
}
@media(max-width:1024px){
    .img_logo_head{
        margin-right: auto;
    }
    .navbar.is-fixed-top .navbar-item img {
    max-height: 4rem !important;
}
.navbar {
    min-height: 5rem !important;
}
.navbar-brand{
    position: absolute;
    left: 15px;
    top: -3px;
}
    span.navbar-burger{
    order: -1;
    margin-right: auto;
    margin-left: 10px;
    color: #fff !important;
    }
.navbar-brand{
    width: 100%;
    align-items: center !important;
    padding-right: 30px;
}
.navbar-menu , a.navbar-burger{
display: none !important;
}
.mob_nav{
    display: flex !important;
}

// sidebar 
.uk-nav{
    display: flex !important;
    flex-direction: column !important;
    a{
        color: #555555 !important;
        font-weight: 500;
        margin-bottom: 4px !important;
    }
    a.router-link-exact-active{
        color: var(--active_color2) !important;
    }

}
#offcanvas-sidebar .uk-offcanvas-bar{
    padding: 0px 20px;
    background-color: #1c0a00;
}
.logo_sidebar{
    text-align: center;
    img{
   width: 140px;
    height: 120px;
    padding: 10px 0px;
    margin-bottom: 20px;
    -o-object-fit: contain;
    object-fit: contain;
    }
}
.uk-margin-auto-vertical{
    margin-top: 20px !important;
a{
    color: black !important;
    font-size: 24px !important;
    margin-bottom: 26px !important;
}
}
}
@media(max-width:992px){
#nav {
    display: flex;
    align-items: center;
    justify-content: center;
}
.logo{
    width: 120px;
    margin-right: 0px !important;
}
.side_menu{
    position: absolute;
    left: 10px;
}
    .web_link{
        display: none;
    }
    .login{
    display: none;
}
.side_menu{
    display: block;
    position: absolute;
    right: 70px;
    font-size: 36px !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 48px;
}
.router-link-active{
    background-color: transparent !important;
    color: white !important;
}
}
</style>
<style lang="scss" scoped>
.uk-nav-sub{
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 5px;
    left: 0;
    width: 100%;
    justify-content: space-around;
    padding-left: 0 !important;
    color: white;
    ion-icon{
        color: var(--active_color);
        font-size: 40px;
    }
    a{
        flex-direction: column;
         color: var(--active_color) !important;
    }
    .name_icon{
        font-size: 18px;
       color: var(--active_color);
    }
}
.ico_nav{
    padding-right: 5px;
    padding-bottom: 2px;
}
.navbar.is-fixed-bottom, .navbar.is-fixed-top{
    display: flex;
    align-items: center;
    .navbar-item img {
    max-height: 4.2rem;
}
// cart button
.button.is-light{
        background-color: transparent !important;
    border-color: transparent !important;
    color: var(--white_color);
    i{
        font-size: 28px;
    }
}
}
.navbar-item, .navbar-link {
    font-size: 14px;
    color: #fff;
    display: block;
    padding: 0.3rem 0.75rem;
    position: relative;
    border-radius: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
}
a.navbar-item:focus, a.navbar-item:focus-within, a.navbar-item:hover, a.navbar-item.is-active, .navbar-link:focus, .navbar-link:focus-within, .navbar-link:hover, .navbar-link.is-active {
    background-color: #e2e2e2;
    color: #010800;
}
.buttons strong{
    display: flex;
    align-items: center;
    font-weight: 400;
    ion-icon{
        font-size: 24px;
        margin-right: 4px;
    }
}
 .cart_btn{
     position: relative;
     min-width: 50px;
     ion-icon{
    position: absolute;
    font-size: 24px;
    font-weight: 700;
     }
    .cart_no{
    background-color: white;
    color: black;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    font-weight: 600;
    top: -2px;
    right: -4px;
    font-size: 13px;
    box-shadow: 0px 0px 2px #363636;
    position: absolute;
    i{
        color: var(--active_color);
    }
     }
    }
    .img_logo_head{
        &::after{
            display: none !important;
        }
    }
   #nav  .router-link-exact-active , .active_meny .exact_active {
       background-color: transparent;
       color: var(--active_color) !important;
       font-weight: 600;
       &::after{
            content: "";
            position: absolute;
            width: 60%;
            height: 2px;
            bottom: 0;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;
            background-color: var(--active_color);
       }
    }
    #nav .img_logo_head{
        background-color: transparent !important;
    }
</style>